import { useCallback, useEffect, useState } from 'react';
import { subirDocumento, actualizarDocumento, eliminarDocumento,
  obtenerDocumentos, descargarDocumento 
} from '../../services/vehiculosService';

export const useDocumentos = (vehiculo) => {
  const [documentos, setDocumentos] = useState({});
  const [loading, setLoading] = useState(false);

  const listarDocumentos = useCallback(async () => {
    if (!vehiculo) return;

    try {
      setLoading(true);

      const data = await obtenerDocumentos(vehiculo.id_vehiculo);
      
      // Transformar objeto en mapa
      const docsMap = {};
      data.forEach(doc => {
        docsMap[doc.tipo_documento] = doc;
      });

      setDocumentos(docsMap);

    } catch (error) {
      console.error('Error cargando documentos:', error);

    } finally {
      setLoading(false);
    }
  }, [vehiculo]);

  useEffect(() => {  listarDocumentos(); }, [listarDocumentos]);

  // Subir documento
  const handleCargar = async (tipo_documento, formData, onProgress) => {
    try {
      // Subir documento
      const resp = await subirDocumento(vehiculo.patente, tipo_documento, formData, onProgress);
      // Recargar listado de documentos  
      await listarDocumentos();

      return ({ok: true, msg: resp.msg });

    } catch (error) {
      console.error(error);
      return ({ ok: false, msg: error?.message || error });
    }
  };

  // Actualizar documento
  const handleActualizar = async (tipo_documento, formData) => {
    try {
      const resp = await actualizarDocumento(vehiculo.patente, tipo_documento, formData);
      
      await listarDocumentos();

      return ({ok: true, msg: resp.msg });
      
    } catch (error) {
      console.error(error);
      return ({ ok: false, msg: error?.message || error });
    }
  };

  // Descargar documento
  const handleDescargar = async (key, data) => {
    try {
      const response = await descargarDocumento(data.id_documento);

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = data.nombre_archivo || `${key}.pdf`;
      link.click();

      window.URL.revokeObjectURL(url);

      return ({ ok: true });

    } catch (error) {
      console.error(error);
      return ({ ok: false, msg: error?.message || error });
    }
  };

  // Eliminar documento
  const handleEliminar = async (id_documento) => {
    try {
      const resp = await eliminarDocumento(id_documento);
      
      await listarDocumentos();

      return ({ok: true, msg: resp.msg });
      
    } catch (error) {
      console.error(error);
      return ({ ok: false, msg: error?.message || error });
    }
  };

  return {
    documentos,
    loading,
    listarDocumentos,
    handleCargar,
    handleActualizar,
    handleDescargar,
    handleEliminar
  };
}